import { Checkbox } from '@progress/kendo-react-inputs';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

export default function CheckBoxCell(props) {
  const [checked, setChecked] = useState(
    props.dataItem[props.field] === 'true' ||
    props.dataItem[props.field] === true
  );

  useEffect(() => {
    setChecked(
      () =>
        props.dataItem[props.field] === 'true' ||
        props.dataItem[props.field] === true
    );
  }, [props.dataItem, props.field]);

  return (
    <td>
      <Checkbox style={{ border: 'solid #147bfc' }}
        checked={checked}
        disabled={(props.enableCheckbox === props.field) || (props.dataItem.inEdit === true && props.updatable) ? false : true}
        onClick={() => {
          setChecked(!checked);
          props.dataItem[props.field] = String(!checked);
          props.onChange({
            field: props.field,
            dataItem: props.dataItem,
            value: !checked,
          });
        }}
      />
    </td>
  );
}

CheckBoxCell.propTypes = {
  dataItem: PropTypes.any,
  field: PropTypes.any,
  enableCheckbox: PropTypes.string,
  updatable: PropTypes.any,
  onChange: PropTypes.any
};
